import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import lfLogoFull from "@/assets/logos/lf-logo-full.svg";
import OpenAIIcon from "@/components/icons/OpenAIIcon";
import { FEATURE_FLAGS, CHATBOT_URL } from "@/config/featureFlags";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background">
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img src={lfLogoFull} alt="Leadership Focus Logo" className="h-10 w-auto brightness-0 invert" />
            </div>
            <p className="text-sm text-background/60 leading-relaxed">
              Beratung, Qualifizierung, Coaching und Supervision. Mit Erfahrung, Empathie, Künstlicher Intelligenz und wissenschaftlicher Fundierung.
            </p>
            {FEATURE_FLAGS.showChatBot && (
              <a
                href={CHATBOT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-background/60 hover:text-background transition-colors mt-3"
              >
                <OpenAIIcon className="h-4 w-4 shrink-0" />
                Leadership Focus Chat
              </a>
            )}
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider mb-4 text-background/80">
              Navigation
            </h4>
            <ul className="space-y-2">
              {[
                { label: "Home", href: "/" },
                { label: "Leadership-Refugium", href: "/leadership-refugium" },
                { label: "Lösungen", href: "/#portfolio" },
                { label: "Unsere Haltung", href: "/#unsere-haltung" },
                { label: "Wer wir sind", href: "/#wer-wir-sind" },
                { label: "Veröffentlichungen", href: "/#blog" },
                { label: "Partnernetzwerk", href: "/#partnernetzwerk" },
                { label: "Referenzen", href: "/#partner" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-background/60 hover:text-background transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider mb-4 text-background/80">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="text-sm text-background/60 space-y-3">
                <div>Leadership Focus GmbH</div>
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 shrink-0" />
                  <span>Leopoldstr. 77, 80802 München</span>
                </div>
              </li>
              <li className="flex items-center gap-2 text-sm text-background/60">
                <Mail className="h-4 w-4 shrink-0" />
                <a href="mailto:kontakt@leadership-focus.de" className="hover:text-background transition-colors">
                  kontakt (at) leadership-focus.de
                </a>
              </li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="font-serif text-sm font-semibold uppercase tracking-wider mb-4 text-background/80">
              Rechtliches
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/impressum" className="text-sm text-background/60 hover:text-background transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/agbs" className="text-sm text-background/60 hover:text-background transition-colors">
                  AGBs
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background/10 text-center text-sm text-background/40">
          © {new Date().getFullYear()} Leadership Focus GmbH. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
